angular.module('WTG.L',[]).factory('L',function() {
 /* TODO: this is a temporary as we don't have a well-defined non-angular module for it and feed off of globals */
 return WTG.L;
});

angular.module('WTG.C11N',[]).factory('C11N',function() {
 return C11N;
});
